export default __webpack_public_path__ + "static/CPS-9b9d6c1401223199d6637316100e174a.png";